module.exports = __webpack_public_path__ + "media/images/icons/whatsapp-681a24bac6ce67ef84bbff6285b8d751.svg";